
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0C6.21 0 1.5 4.262 1.5 9.5c0 5.749 7.3 12.286 9.54 14.152a1.5 1.5 0 001.921 0C15.2 21.784 22.5 15.246 22.5 9.5 22.5 4.262 17.79 0 12 0zm6.97 9.672a.5.5 0 01-.47.328h-1a.5.5 0 00-.5.5V15a.5.5 0 01-.5.5H14a.5.5 0 01-.5-.5v-2.25a1.5 1.5 0 00-3 0V15a.5.5 0 01-.5.5H7.5A.5.5 0 017 15v-4.5a.5.5 0 00-.5-.5h-1a.5.5 0 01-.323-.882l6.5-5.5a.5.5 0 01.647 0l6.5 5.5a.5.5 0 01.146.554z"}})])
          )
        }
      }
    